import stylesheet from './Image.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

export class NXTImage extends CustomComponent {
    static observedAttributes = ['aspect-ratio', 'aspect-ratio-md', 'aspect-ratio-lg', 'aspect-ratio-xl', 'height'];

    container: HTMLElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    setImageStyleProperties() {
        this.style.setProperty('--aspect-ratio', this.getAttribute('aspect-ratio') ?? 'auto');
        this.style.setProperty('--aspect-ratio-md', this.getAttribute('aspect-ratio-md') ?? null);
        this.style.setProperty('--aspect-ratio-lg', this.getAttribute('aspect-ratio-lg') ?? null);
        this.style.setProperty('--aspect-ratio-xl', this.getAttribute('aspect-ratio-xl') ?? null);
        this.style.setProperty('--nxt-image-height', this.getAttribute('height') ?? null);
    }

    render() {
        this.container = document.createElement('div');
        this.container.classList.add('nxt-image');
        this.setImageStyleProperties();
        this.cloneDefaultSlotContentIntoContainer(this.container, false);
        return this.container;
    }

    attributeChangedCallback() {
        this.setImageStyleProperties();
    }
}

customElements.define('nxt-image', NXTImage);
